import styled from 'styled-components';
import MaterialAvatar from '@material-ui/core/Avatar';
import { RalewayFont } from 'constants/fonts';
import { skyBlue, white, black } from 'constants/colors';
import { TABLET_WIDTH } from 'constants/breakPoints';
import searchIcon from 'assets/images/icons/search.svg';

export const NoMessagesLayer = styled.div`
  display: block !important;
  flex-direction: unset !important;
  height: 100%;
  width: 100%;
  background-color: ${props => props.color};
`;


export const ChatListWrapper = styled.div`
  display: block !important;
  flex-direction: unset !important;
  height: calc(100vh - 107px);
  position: relative;
  width: 100%;
  overflow: auto;

  @media (max-width: ${TABLET_WIDTH}px) {
    height: calc(100vh - 170px);
  }

  .chat_grid {
    white-space: nowrap;
    height: calc(100% - 7.4rem);
    .chats_list {
      white-space: initial;
      display: ${props => (props.selectedChat ? 'inline-block' : 'block')};
      vertical-align: top;
      width: ${props => (props.selectedChat ? '50rem' : '100%')};
      height: 100%;
      overflow: auto;
      padding-bottom: 3rem;

      @media (max-width: ${TABLET_WIDTH}px) {
        width: 100%;
        padding-right: 0;
      }
    }

    .selected_chat {
      white-space: initial;
      display: inline-block;
      vertical-align: top;
      background-color: #fff;
      height: 100%;
      width: calc(100% - 50rem);
      box-shadow: 0px -2px 6px 1px rgb(0 0 0 / 20%);

      .chat_wrapper {
        height: 100%;

        .chat_header {
          box-shadow: 2px 0px 6px 1px rgb(0 0 0 / 20%);
          position: relative;
          z-index: 8;

          .back_arrow {
            display: none;
          }
        }

        .chat_container {
          height: calc(100% - 6rem);

          .chat_messages {
            height: calc(100% - 6rem);
          }
        }
      }
    }
  }

  .no_elements {
    div {
      color: ${black};
    }
  }
`;

export const ChatsWrapper = styled.div`
  margin-top: 1rem;
  background-color: #f5f5f5;
  height: calc(100vh - 90px);
  padding-bottom: 50px;
`;


export const ImageChatsLayer = styled.div`
  position: relative;
  margin-top: 30px;

  .image_chat_icon {
    text-align: center;
    img {
      width: 80%;
      max-width: 250px;
    }
  }

  .no_chats_message {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }
`;

export const MatchesChats = styled.div`
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #fff;
`;

export const ChatsList = styled.div`
  margin: 2rem;
  .title_chats {
    font-family: ${RalewayFont.regularFamily};
    color: ${black};
    font-size: 2.2rem;
    margin: 1rem 0 2rem;
  }
`;

export const Minititle = styled.div`
  color: ${props => props.text};
  font-size: 14px;
  font-weight: 600;
  padding: 8px;
  margin: 10px 0;
  background-color: ${props => props.color};
`;

export const MatchesSlider = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  padding: 10px 0;
`;

export const Chat = styled.div`
  font-family: ${RalewayFont.regularFamily};
  width: 90%;
  padding: 10px;
  background-color: #fafafa;
  position: relative;
  margin-top: 1rem;
  border-radius: 1.5rem;
  box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.20);
  cursor: pointer;
`;

export const UpperInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const LowerInfo = styled.div`
  margin-top: 2rem;
  height: 3rem;
  display: flex;
  align-items: center;
`;

export const UsersInside = styled.div`
  position: relative;
  width: 50%;
  margin-left: 0.5rem;
`;

export const TimeLeft = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
  color: #FFA200;
  font-size: 1.1rem;
`;

export const AvatarWrapper = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  border-radius: 2rem;
  margin-right: 1rem;
`;

export const CreateChatDesktop = styled.div`
  color: ${props => props.color};
  box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.20);
  border-radius: 2rem;
  padding: 1rem 3rem;
  font-size: 2.4rem;
  width: 90%;
  font-family: ${RalewayFont.boldFamily};
  cursor: pointer;

  span {
    font-family: ${RalewayFont.boldFamily};
    font-size: 1.4rem;
    color: ${props => props.color};
    display: inline-block;
    margin-left: 2rem;
    margin-top: -0.3rem;
    vertical-align: middle;
  }

  @media (max-width: ${TABLET_WIDTH}px) {
    display: none;
  }
`;

export const CreateChat = styled.div`
  position: absolute;
  right: 2%;
  bottom: 10%;
  width: 63px;
  height: 63px;
  margin: 2%;
  align-items: center;
  z-index: 10000;

  @media (min-width: ${TABLET_WIDTH}px) {
    display: none;
  }

  button {
    border-style: none;
    background-color: ${skyBlue};
    width: 58px;
    height: 58px;
    padding: 5px;
    border-radius: 50px;

  }
`;

export const FilterContainer = styled.div`
  white-space: nowrap;
  overflow-x: auto;
  padding: 0.5rem 1rem 0;
  box-shadow: inset 0px 3px 6px -2px rgb(0 0 0 / 16%), 0px 3px 6px 1px rgb(0 0 0 / 16%);
  z-index: 9;
  background-color: #fff;
  z-index: 9;
  position: relative;
  padding: 1.2rem 1.5rem;
`;

export const SearchBar = styled.div`
  background-color: ${white};
  border-radius: 50px;
  display: flex;
  float: left;
  align-items: center;
  border: 2px grey;

  @media (max-width: ${TABLET_WIDTH}px) {
    display: block;
    float: none;
  }

  .lensIcon {
    float: left;
    vertical-align: middle;
    margin: 5px;
    width: 15px;
  }

  input {
    background-image: url(${searchIcon});
    background-repeat: no-repeat;
    background-position: 1rem center;
    width: 30rem;
    padding-left: 4rem;
    margin-right: 1rem;

    @media (max-width: ${TABLET_WIDTH}px) {
      width: 100%;
    }
  }
`;

export const EachFilter = styled.div`
  background-color: transparent;
  margin: 15px;
  height: 28px;
  border-radius: 50px;
  border: 2px solid ${white};
  font-family: ${RalewayFont.regularFamily};
  color: ${white};
  align-items: center;
  padding: 5px;
  display: inline-block;
  font-weight: 200;
  font-size: 14px;
`;

export const UserAvatar = styled(MaterialAvatar)`
   && {
    width: ${props => (!props.dead ? '40px' : '40px')};
    height: ${props => (!props.dead ? '40px' : '40px')};
    display: inline-block;
    border-radius: ${props => (!props.dead ? '50%' : '0%')};
    border: ${props => (!props.dead ? '1px solid #ddd' : 'none')};
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      object-fit: cover;
      background-color: #fafafa;
    }

    &.text-avatar {
      font-size: 2rem;
    }
   }
`;

export const UserContent = styled.div`
  display: inline-block;
  vertical-align: top;
  width: 78%;
  .name_indicator{
    position: relative;
    display: flex;
    font-family: ${RalewayFont.boldFamily};
    font-size: 1.4rem;
  }
`;

export const UserName = styled.div`
  font-size: 1.2rem;
  font-family: ${RalewayFont.boldFamily};
  color: #444;
  height: 20px;
  text-overflow: ellipsis;
  display: inline-block;
  width: calc(100% - 60px);
  overflow: hidden;
  white-space: nowrap;
`;

export const ThinkChatTitle = styled.div`
  font-weight: 600;
  font-size: 1rem;
  color: #444;
  height: 20px;
  text-overflow: ellipsis;
  display: inline-block;
  width: calc(100% - 75px);
`;

export const ChatName = styled.div`
  font-size: 14px;
  color: #444;
  height: 20px;
  text-overflow: ellipsis;
  display: inline-block;
  width: calc(100% - 60px);
  overflow: hidden;
  white-space: nowrap;
`;

export const MiniAvatar = styled(MaterialAvatar)`
   && {
    position: absolute;
    top: -15px;
    left: ${props => props.left};
    width: 2.5rem;
    height: 2.5rem;
    display: inline-block;
    border-radius: 50%;
    box-shadow:  0px 0px 6px 1px rgba(0,0,0,0.41);
    border: none;
    img {
      object-fit: cover;
      background-color: #fafafa;
    }

    &.text-avatar {
      font-size: 28px;
      padding-top: 13px;
      text-align: center;
    }
   }
`;

export const MiniNumber = styled(MaterialAvatar)`
   && {
    position: absolute;
    background: white;
    top: -15px;
    left: ${props => props.left};
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: none;
    color: black;
    font-size: 1.1rem;
   }
`;

export const MessageDate = styled.div`
  width: 60px;
  display: inline-block;
  text-align: right;
  color: #888;
  font-size: 1rem;
`;

export const LastMessageText = styled.div`
  color: #444;
  font-size: 1rem;
  height: 1.1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 35px);
  position: relative;
`;

export const IndicatorNews = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 0.5rem;
  background-color: ${props => props.color};
`;

export const BubbleMatchElement = styled.div`
  display: inline-block;
  vertical-align: top;
  text-align: center;
  width: 10rem;
  cursor: pointer;
  margin-right: 10px;

  .avatar_bubble {
    margin: 0 auto;
  }

  .username {
    font-size: 12px;
    font-weight: 600;
    width: 80%;
    white-space: initial;
    margin: 0 auto;
    color: ${black};
    height: 32px;
    margin-top: 0.5rem;
  }
`;

export const AvatarBubbleWrapper = styled.div`
  width: 42px;
  margin: 5px auto;

`;

export const UserBubbleAvatar = styled(MaterialAvatar)`
  && {
    width: 42px;
    height: 42px;
    display: inline-block;

    img {
      object-fit: contain;
      background-color: #eee;
    }

    &.text-avatar {
      font-size: 24px;
      padding-top: 9px;
      text-align: center;
    }
   }
`;

export const Subtitle = styled.div`
  font-size: 13px;
  color: #fff;
  margin-right: 22px;
  margin-left: 22px;
  text-align: left;
`;

export const NewChatContainer = styled.div`
   font-family: ${RalewayFont.regularFamily};

   .new_chat_title {
    font-family: ${RalewayFont.regularFamily};
    font-size: 16px;
    text-align: center;
    color: ${black};
    margin: 2rem;
  }
`;

export const NewChatHeader = styled.div`
   height: 45px;
   color: black;
   font-size: 16px;
   font-weight: bold;
   display: flex;
   margin-top: env(safe-area-inset-top);
   align-items: center;

   .arrowback {
     float: left;
     height: 45px;
     margin-left: 2rem;
   }

  div {
    float: left;
    width: 85%;
    height: 45px;
    padding: 15px 0px;

    @media (max-width: ${TABLET_WIDTH}px){
      width: 47vw;
    }
  }

  .search_lens {
    height: 45px;
    padding: 10px;
    @media (max-width: ${TABLET_WIDTH}px){
      margin-left: 11%;
    }
   }

   .infocircle {
     float: right;
     height: 45px;
     padding: 10px;
   }
`;

export const NewChatFilter = styled.div`
   background-color: ${white};
   width: 334px;
   height: 28px;
   border-radius: 50px;
   margin: 9px;

   @media (max-width: ${TABLET_WIDTH}px){
    width: 334px;
   }

   img {
      float: left;
      width: 18px;
      height: 18px;
      margin: 6px;
   }

   input {
    font-family: ${RalewayFont.regularFamily};
    color: #30423E;
    font-size: 16px;
    border: none;
    width: 70%;
    height: 28px;

    @media (max-width: ${TABLET_WIDTH}px){
      width: 280px;
    }

  }

`;

export const NewChatGrid = styled.div`
  width: 90%;
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  grid-template-rows: 150px;
  margin: 2rem 5%;

  @media (max-width: ${TABLET_WIDTH}px) {
    grid-template-columns: 30% 30% 30%;
    grid-template-rows: 150px 150px 150px;
  }

`;



// WEBPACK FOOTER //
// ./src/components/Chats/components/styles.js